"use client";
import { useState, type ReactNode } from "react";
import dynamic from "next/dynamic";
const AnimateHeight = dynamic(() => import("react-animate-height"), {
  ssr: false,
});
import Link from "next/link";

interface CollapseProps {
  children?: ReactNode;
  href: string;
  title: ReactNode;
  /** Fired when a leaf link is followed, so the parent can close the menu. */
  onNavigate?: () => void;
}

export default function Collapse({
  children,
  href,
  title,
  onNavigate,
}: CollapseProps) {
  const [active, setActive] = useState(false);

  const onCollapse = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setActive((v) => !v);
  };

  return (
    <li className="nav-item">
      <div className={active ? "nav-link active" : "nav-link"}>
        <Link href={href} onClick={onNavigate}>
          {title}
        </Link>
        {children && (
          <button
            type="button"
            className="btn-toggle"
            aria-expanded={active}
            aria-label={active ? "Collapse submenu" : "Expand submenu"}
            onClick={onCollapse}
          >
            <i className="icon"></i>
          </button>
        )}
      </div>
      {children && (
        <AnimateHeight duration={300} height={active ? "auto" : 0}>
          {children}
        </AnimateHeight>
      )}
    </li>
  );
}
